import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, Wrench, Mail, AlertTriangle } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEOHead from '../components/SEOHead';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <SEOHead 
        title="Page Not Found | Gray Contracting"
        description="The page you're looking for doesn't exist. Return to Gray Contracting's homepage or contact us for assistance."
        canonical="/404"
      />
      {/* Add noindex meta tag */}
      <meta name="robots" content="noindex, follow" />
      
      <div className="max-w-lg text-center">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-amber-600" />
        </div>
        
        <h1 className="text-4xl font-bold text-neutral-900 mb-4">Page Not Found</h1>
        <p className="text-neutral-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It may have been moved or no longer exists.
        </p>
        
        <div className="grid grid-cols-2 gap-4 mb-8">
          <Link to="/">
            <Button variant="outline" className="w-full">
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
          </Link>
          <Link to="/services">
            <Button variant="outline" className="w-full">
              <Wrench className="w-4 h-4 mr-2" />
              Services
            </Button>
          </Link>
          <Link to="/services/mold-remediation">
            <Button variant="outline" className="w-full">
              Mold Remediation
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="w-full">
              <Mail className="w-4 h-4 mr-2" />
              Contact
            </Button>
          </Link>
        </div>
        
        <div className="bg-white border border-neutral-200 rounded-lg p-4">
          <p className="text-sm text-neutral-600 mb-2">Need help? Call us directly:</p>
          <a href="tel:+12149087644" className="inline-flex items-center gap-2 text-amber-600 font-semibold hover:text-amber-700">
            <Phone className="w-4 h-4" />
            214-908-7644
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
